// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"6be2472d","513":"ca92b1a6","703":"4cff7f81"}[chunkId] + ".chunk.js";
};